export function generateZeroRatingProps(isZeroRatingEnabled: boolean) {
  if (!isZeroRatingEnabled || typeof window === 'undefined') {
    return {};
  }

  const parts = window.location.href.split('.');

  // Extract the subdomain (stXX or intXX)
  const subdomain = parts[0].split('-')[1];

  if (!subdomain) {
    return {
      host: `hcaptcha.spark.co.nz`,
      apihost: `https://hcaptcha.spark.co.nz`,
      assethost: `https://assets.hcaptcha.spark.co.nz`,
      imghost: `https://images.hcaptcha.spark.co.nz`,
      reportapi: `https://accounts.hcaptcha.spark.co.nz`,
      endpoint: 'https://api.hcaptcha.spark.co.nz',
    };
  }

  return {
    host: `${subdomain}.hcaptcha.spark.co.nz`,
    apihost: `https://${subdomain}.hcaptcha.spark.co.nz`,
    assethost: `https://assets-${subdomain}.hcaptcha.spark.co.nz`,
    imghost: `https://images-${subdomain}.hcaptcha.spark.co.nz`,
    reportapi: `https://accounts-${subdomain}.hcaptcha.spark.co.nz`,
    endpoint: `https://api-${subdomain}.hcaptcha.spark.co.nz`,
  };
}
